import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SharedService} from "../../shared/shared.service";
import {LocalStorageService} from "ngx-localstorage";
// Allianz AEM
import {
  EmbeddedDataModule,
  EmbeddedDataService,
  NORMALIZE_URL_SERVICE_CONFIG_TOKEN,
  NormalizeUrlModule,
  NormalizeUrlService
} from '@allianz/ngx-aem-integration'

interface IFooterButton {
  text: string;
  mode: 'primary' | 'secondary';
  disabled?: boolean;
  icon?: string;
  callback: () => void;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public activeLanguage = {name: 'Bulgarian', code: 'bg'};
  public languages = [{name: 'English', code: 'en'}, {name: 'Bulgarian', code: 'bg'}];

  constructor(public translateService: TranslateService,
              public localStorage: LocalStorageService,
              public chr: ChangeDetectorRef, public sharedService: SharedService, public normalizeUrlService: NormalizeUrlService) {
  }

  ngOnInit(): void {
  }

  setLanguage(language) {
    this.localStorage.set('language', language.code);
    this.translateService.use(language.code);
    this.translateService.setDefaultLang(language.code);
      this.sharedService.updateEnums(this.normalizeUrlService);
      this.chr.detectChanges();
  }

}
